import {
  BookOpen, Globe, Target, Award, Lightbulb
} from 'lucide-react';

export const atAGlance = [
  { label: 'Program Name', value: 'Master of Humanitarian Action & Development' },
  { label: 'Duration', value: '1 Year' },
  { label: 'Mode of Delivery', value: '100% Online' },
  { label: 'Curriculum', value: '9 Courses + Capstone Field Project' },
  { label: 'Full Program Fee', value: 'USD 2,000' },
  { label: 'Scholarship', value: '90% available for Afro-Asia students' },
  { label: 'Learning Format', value: 'Flexible online study' },
  { label: 'Final Component', value: 'Capstone Field Project' },
  { label: 'Documents Issued', value: 'Master\'s Degree Certificate and Academic Transcript, subject to successful completion' },
];

export const whoIsFor = [
  'Early- to mid-career professionals',
  'NGO and humanitarian practitioners',
  'Development and public service professionals',
  'Civil society and social impact professionals',
  'Career changers entering the humanitarian or development sector',
  'Recent graduates seeking a structured professional pathway',
  'Learners interested in humanitarian action, development, emergency response, protection, MEAL, logistics, donor systems, and leadership'
];

export const entryRequirements = [
  'A bachelor\'s degree or equivalent qualification',
  'Proficiency in English',
  'Demonstrated interest in humanitarian action or development',
  'Ability to engage effectively in an online learning environment'
];

export const whyChooseFeatures = [
  {
    icon: BookOpen,
    title: 'Professionally Relevant Curriculum',
    description: 'The curriculum is connected to contemporary humanitarian and development practice, covering essential areas such as humanitarian principles, international law, program management, MEAL, emergency response, donor systems, protection, logistics, and coordination.'
  },
  {
    icon: Globe,
    title: 'Flexible Online Delivery',
    description: 'The program is delivered fully online, allowing learners to study alongside work, family, field responsibilities, or other professional commitments.'
  },
  {
    icon: Target,
    title: 'Global Perspective',
    description: 'The program is informed by international debates, humanitarian principles, development practice, and diverse field realities.'
  },
  {
    icon: Award,
    title: 'Accessible Pathway',
    description: 'The program provides a scholarship-supported learning opportunity for eligible applicants from Africa and Asia who are committed to humanitarian and development work.'
  },
  {
    icon: Lightbulb,
    title: 'Applied Learning',
    description: 'The program supports learners in developing practical judgment, leadership potential, and professional confidence through structured coursework and a capstone project.'
  }
];

export const learningOutcomes = [
  'Apply humanitarian principles, international humanitarian law, and ethical judgment in crisis contexts',
  'Design, implement, and manage humanitarian programs and projects effectively',
  'Develop MEAL systems that support impact, accountability, and learning',
  'Plan for and respond to emergencies, disasters, and early recovery needs',
  'Navigate donor systems and prepare compliant proposals, budgets, and reports',
  'Integrate protection, gender, and inclusion across humanitarian action',
  'Understand logistics, procurement, and field operations in complex environments',
  'Lead teams and coordinate effectively within the humanitarian system',
  'Build professional confidence for roles in humanitarian, development, NGO, public sector, and social impact settings'
];

export const courses = [
  {
    number: '01',
    title: 'Foundations of Humanitarian Action',
    duration: '1 Month',
    description: 'This course introduces learners to the foundations of humanitarian action, including its history, major actors, coordination structures, and contemporary challenges.',
    topics: [
      'History of humanitarianism and its evolution',
      'Key actors in the humanitarian system (UN, NGOs)',
      'Humanitarian architecture and coordination mechanisms',
      'Contemporary challenges and trends in humanitarian response',
      'Introduction to humanitarian standards (Sphere, CHS)'
    ]
  },
  {
    number: '02',
    title: 'Humanitarian Principles & International Law',
    duration: '1 Month',
    description: 'This course explores the legal, ethical, and principled foundations of humanitarian action.',
    topics: [
      'Core humanitarian principles',
      'International Humanitarian Law (IHL) fundamentals',
      'International Human Rights Law and Refugee Law',
      'Protection of civilians in armed conflict',
      'Ethical dilemmas and decision-making in humanitarian contexts'
    ]
  },
  {
    number: '03',
    title: 'Program & Project Management in NGOs',
    duration: '1 Month',
    description: 'This course supports learners in understanding how humanitarian and development programs and projects are designed, planned, implemented, monitored, and adapted.',
    topics: [
      'Project cycle management in humanitarian contexts',
      'Needs assessment and program design',
      'Logical frameworks and theory of change',
      'Budget development and financial management',
      'Risk management and adaptive programming'
    ]
  },
  {
    number: '04',
    title: 'Monitoring, Evaluation, Accountability & Learning (MEAL)',
    duration: '1 Month',
    description: 'This course introduces MEAL systems and their role in improving program quality, accountability, learning, and evidence-based decision-making.',
    topics: [
      'MEAL frameworks and indicator development',
      'Data collection methods and tools',
      'Accountability to affected populations (AAP)',
      'Community feedback mechanisms',
      'Learning and knowledge management'
    ]
  },
  {
    number: '05',
    title: 'Emergency Response & Disaster Management',
    duration: '1 Month',
    description: 'This course focuses on emergency response, disaster management, preparedness, and early recovery.',
    topics: [
      'Disaster risk reduction and preparedness',
      'Emergency response mechanisms and rapid assessment',
      'Camp coordination and management',
      'Search and rescue operations overview',
      'Early recovery and transition programming'
    ]
  },
  {
    number: '06',
    title: 'Donor Systems & Proposal Development',
    duration: '1 Month',
    description: 'This course introduces learners to humanitarian donor systems, proposal development, compliance, budgeting, and reporting.',
    topics: [
      'Overview of major humanitarian donors (USAID, ECHO, UN agencies)',
      'Understanding donor requirements and compliance',
      'Proposal writing techniques and best practices',
      'Budget narratives and cost allocation',
      'Grant management and donor reporting'
    ]
  },
  {
    number: '07',
    title: 'Protection, Gender & Inclusion',
    duration: '1 Month',
    description: 'This course explores protection, gender, inclusion, and safeguarding considerations in humanitarian action.',
    topics: [
      'Protection mainstreaming in humanitarian response',
      'Gender analysis and gender-responsive programming',
      'Child protection in emergencies',
      'Gender-based violence prevention and response',
      'Inclusion of persons with disabilities and marginalized groups'
    ]
  },
  {
    number: '08',
    title: 'Logistics & Operations in Humanitarian Response',
    duration: '1 Month',
    description: 'This course introduces core operational functions that support humanitarian response and field implementation.',
    topics: [
      'Humanitarian supply chain management',
      'Procurement principles and procedures',
      'Warehouse and inventory management',
      'Fleet management and transportation',
      'Security management and duty of care'
    ]
  },
  {
    number: '09',
    title: 'Leadership & Coordination in the Humanitarian System',
    duration: '1 Month',
    description: 'This course focuses on leadership, coordination, negotiation, and team management in humanitarian settings.',
    topics: [
      'Leadership styles and emotional intelligence',
      'The cluster system and humanitarian coordination',
      'Civil-military coordination',
      'Negotiation and advocacy skills',
      'Managing teams in high-stress environments'
    ]
  },
  {
    number: '10',
    title: 'Capstone Field Project',
    duration: '3 Months',
    description: 'The capstone project allows learners to apply their knowledge to a humanitarian or development issue, project, program, or operational challenge.',
    topics: [
      'Project identification and scoping',
      'Research methodology and data collection',
      'Stakeholder engagement and coordination',
      'Implementation and documentation',
      'Final presentation and peer review'
    ],
    isCapstone: true
  }
];

export const careerPathways = {
  programOps: {
    title: 'Program & Operations',
    roles: ['Program Officer', 'Project Officer', 'Logistics and Operations Officer', 'Field Officer / Field Manager']
  },
  technical: {
    title: 'Technical & Support Functions',
    roles: ['MEAL Officer', 'Protection Officer', 'Proposal Development Officer', 'Grants and Donor Relations Officer']
  },
  leadership: {
    title: 'Coordination & Leadership',
    roles: ['Humanitarian Coordination Officer', 'NGO Program Manager', 'Field Coordinator', 'Project Manager']
  }
};

export const admissionsSteps = [
  { step: 1, title: 'Application Submission', description: 'Applicants complete the online application form and submit the required information.' },
  { step: 2, title: 'Application Review', description: 'The Admissions Team reviews the application and eligibility for the program and scholarship.' },
  { step: 3, title: 'Admissions Offer', description: 'Successful applicants may receive an admissions offer and scholarship confirmation.' },
  { step: 4, title: 'Tuition Payment', description: 'Applicants complete the required tuition payment to confirm admission.' },
  { step: 5, title: 'Program Begins', description: 'Confirmed students receive program access and begin their online learning pathway.' }
];

export const faqs = [
  { question: 'Is the program fully online?', answer: 'Yes. The program is delivered entirely online and is designed to be accessible to learners across different locations.' },
  { question: 'Who is eligible for the Afro-Asia Scholarship?', answer: 'The scholarship is available to eligible applicants from Africa and Asia who are committed to humanitarian work.' },
  { question: 'What is the full program fee?', answer: 'The full tuition for the Master of Humanitarian Action & Development is USD 2,000 for the entire 1-year program. Eligible Afro-Asia students may apply for our 90% scholarship.' },
  { question: 'What documents are awarded upon completion?', answer: 'Eligible graduates may receive a Master\'s Degree Certificate and Academic Transcript upon successful completion of the program and fulfilment of all academic requirements.' },
  { question: 'Can working professionals apply?', answer: 'Yes. The program is designed to support learners seeking flexible online study alongside professional responsibilities.' },
  { question: 'Do I need prior humanitarian experience to apply?', answer: 'Not necessarily. The program is open to applicants from relevant academic and professional backgrounds, including early-career professionals and career changers.' },
  { question: 'How do I apply?', answer: 'Applicants must complete the application form, submit the required documents, and undergo admission and scholarship review by the Institute.' },
  { question: 'Is English required?', answer: 'Yes. Applicants should have sufficient English proficiency to study, complete assignments, and engage with online learning materials.' },
  { question: 'How long does the program take?', answer: 'The program is designed to be completed over one year.' },
  { question: 'What is the final project?', answer: 'The program includes a capstone project that allows learners to apply their knowledge to a humanitarian or development issue, project, program, or operational challenge.' }
];
